///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../abstract-command';
import { GtthCreateTerminalCommand } from './node/create-terminal-command';
import { GtthCreateLinkCommand } from './link/create-link-command';

import { ActivityDTO } from '../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../shared/preloader-modal/preloader-modal-event';
import { GtthNodeFeatureDtoModel } from '../../../../services/project-socket/dto/gtth-node-feature-dto.model';
import { GtthLinkFeatureDtoModel } from '../../../../services/project-socket/dto/gtth-link-feature-dto.model';
import { GtthRemoveMultipleEntitiesCommand } from './remove-multiple-entities-command';

export class GtthCreateMultipleEntitiesCommand extends GtthAbstractCommand {
    private nodes: GtthNodeFeatureDtoModel[];
    private links: GtthLinkFeatureDtoModel[];

    create(nodes: GtthNodeFeatureDtoModel[], links: GtthLinkFeatureDtoModel[]): this {
        this.nodes = nodes;
        this.links = links;
        return this;
    }

    getCommandName(): string {
        return 'GtthCreateMultipleEntitiesCommand';
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const activity = this.createActivityDTO(false);
        activity.links = [...this.links];
        activity.nodes = [...this.nodes];
        this.sendActivity(activity);
    }

    undoCommand(): void {
        const terminalIds = this.nodes && this.nodes.length > 0 ? this.nodes.map((node) => node.getId()) : [];
        const linkIds = this.links && this.links.length > 0 ? this.links.map((link) => link.getId()) : [];

        const removeMultipleEntitiesCommand = this.historyService.command(GtthRemoveMultipleEntitiesCommand).create(terminalIds, linkIds);

        this.historyService.doCommandBypassHistory(removeMultipleEntitiesCommand).then((result: boolean) => {
            if (this.commandResolve) {
                this.commandResolve(result);
            }
        });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            this.historyService.eventManager.broadcast({
                name: 'togglePreloaderModal',
                eventObject: GtthPreloaderModalEvent.hide()
            });

            this.historyService.notificationService.showError(activityDto?.error?.message);

            if (this.commandResolve) {
                this.commandResolve(activityDto.successful);
            }
        } else {
            const nodesCreateCommands = [];
            const linksCreateCommands = [];

            if (activityDto.nodes === undefined) {
                activityDto.nodes = [];
            }

            activityDto.nodes.forEach((terminalGeoJson: GtthNodeFeatureDtoModel) => {
                nodesCreateCommands.push(
                    this.historyService.doCommandBypassHistory(
                        this.historyService.command(GtthCreateTerminalCommand).createFromGeoJson(terminalGeoJson),
                        true
                    )
                );
            });
            this.nodes = activityDto.nodes;

            Promise.all(nodesCreateCommands).then((_nodesCreateRes) => {
                if (activityDto.links === undefined) {
                    activityDto.links = [];
                }

                activityDto.links.forEach((linkGeoJson: GtthLinkFeatureDtoModel) => {
                    linksCreateCommands.push(
                        this.historyService.doCommandBypassHistory(
                            this.historyService.command(GtthCreateLinkCommand).createFromGeoJson(linkGeoJson),
                            true
                        )
                    );
                });
                this.links = activityDto.links;

                Promise.all(linksCreateCommands).then((_linksCreateRes) => {
                    if (this.commandResolve) {
                        this.commandResolve(true);
                    }

                    this.historyService.eventManager.broadcast({
                        name: 'togglePreloaderModal',
                        eventObject: GtthPreloaderModalEvent.hide()
                    });
                });
            });
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isModifyTopology(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return true;
    }
}
